import { render, staticRenderFns } from "./app-settings.vue?vue&type=template&id=248ff588&"
import script from "./app-settings.vue?vue&type=script&lang=js&"
export * from "./app-settings.vue?vue&type=script&lang=js&"
import style0 from "./app-settings.vue?vue&type=style&index=0&id=248ff588&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports